import type { CandidateProcess } from '@entities/candidates';

export const getSenderDisplayName = (
  sender: CandidateProcess['sender']
): string => {
  if (!sender) {
    return 'CYNTHIA';
  }

  if (sender.firstName || sender.lastName) {
    const parts = [sender.firstName, sender.lastName].filter(Boolean);
    return parts.join(' ');
  }

  return 'CYNTHIA';
};
